/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A partir de aquí iremos creando una Pokédex con las 4 diferentes tecnologías.`}</p>
    <p>{`La Pokédex tendrá 3 componentes:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`<Pokedex />`}</inlineCode></strong>{`: Contiene el estado y hace las peticiones a la API.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`<PokedexScreen />`}</inlineCode></strong>{`: Muestra la información del Pokémon y si ha ocurrido un error.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`<PokedexForm />`}</inlineCode></strong>{`: Nos ayuda a encontrar cualquier Pokémon.`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`<Stat />`}</inlineCode></strong>{`: Su función es renderizar cada una de las estadísticas del Pokémon.`}</li>
    </ul>
    <p>{`Puedes crearlos después de mirar el ejemplo que hicimos con `}<inlineCode parentName="p">{`<Pokedex />`}</inlineCode>{` y más adelante exploraremos la lógica y el HTML de cada uno de ellos.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;